// Module
var code = `<div class="page"> <div class="panel article_panel"> <span class="panel_title" id="article_title">#TITLE</span> <span id="article_post_time">#POST_TIME</span> <p id="article_content">#CONTENT</p> </div> </div>`;
// Exports
export default code;